import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AppComponent } from '../../app.component';
import { BaseService } from '../../shared/services/base.service';

import { Dealer } from '../../shared/models/dealer.interface';
import { TextEdit } from '../models/text.edit.interface';
import { FileUpload } from '../../shared/models/file.upload.interface';
import { Router } from '@angular/router';
import { WorkOrderDefaultTimes } from '../models/workOrderDefaultTimes.interface';

@Injectable()

export class AccountService extends BaseService {

  constructor(private appComponent: AppComponent, protected http: HttpClient, router: Router) {
    super(http, router);
  }

  getDealer(): Observable<Dealer> {
    return this.httpGet<Dealer>("/dealer/detail");
  }

  updateDealer(dealer: Dealer): Observable<Dealer> {
    return this.httpPut<Dealer>("/dealer/" + dealer.dealer_ID, dealer);
  }

  saveText(type: string, locale: string, dealerText: TextEdit): Observable<number> {
    return this.httpPost<number>(`/dealer/text/${type}/${locale}`, dealerText);
  }

  saveDefaultWorkOrderTimes(workOrderDefaultTimes: WorkOrderDefaultTimes): Observable<number> {
    return this.httpPost<number>(`/dealer/workOrderDefaultTimes`, workOrderDefaultTimes);
  }

  saveLogo(logoFile: FileUpload): Observable<number> {
    return this.httpPost<number>("/dealer/logo", logoFile);
  }

  deleteLogo(): Observable<number> {
    return this.httpDelete<number>("/dealer/logo");
  }

  getStates(): Observable<string[]> {
    return this.httpGet<string[]>("/admin/states");
  }
}
